module.exports = __webpack_public_path__ + "img/delano3.b785cdf2.jpg";